/**
 * @param {Number} left left value
 * @param {Number} right right value
 * @param {Object} options module opts
 * @returns {Boolean} are equal?
 */
const eq = (left, right, options) => left === right ? options.fn(undefined) : options.inverse(undefined);

/**
 * @param {Number} value money val
 * @returns {String} currency format
 */
const currency = value => {
  // eslint-disable-next-line no-new-wrappers
  const numericValue = new Number(value);
  if (numericValue < 1) {
    return value;
  }
  const formatted = (value || value === 0) && new Number(value).toFixed(2).replace(/./g, (character, index, amount) => index && character !== '.' && (amount.length - index) % 3 === 0 ? `,${character}` : character);
  return `\$${formatted || 'XXX,XXX'}`;
};

/**
 * @param {Number} value currency value
 * @returns {String} rounded value
 */
const currencyRoundedInt = value => {
  const numericValue = new Number(value);
  if (numericValue < 1) {
    return `\$${numericValue}`;
  }
  const formatted = (value || value === 0) && new Number(value).toFixed().replace(/./g, (character, index, amount) => index && character !== '.' && (amount.length - index) % 3 === 0 ? `,${character}` : character);
  return `\$${formatted || 'XXX,XXX'}`;
};

/**
 * @param {String} date date string
 * @returns {String} date string
 */
const date = value => value || new Date().toLocaleDateString();

/**
 * @param {Number} value money val
 * @returns {String} currency percentage
 */
const percentage = value => `${value ? new Number(value).toFixed(3) : 'X.XXX'}%`;

/**
 * @param {Number} value zip value
 * @returns {String} formatted zip
 */
const zipcode = value => value ? value.slice(0, 5) : 'XXXXX';

/**
 * @param {Number} value money val
 * @param {String} monthDay month of they day?? :)
 * @param {String} dayMonth day of the month
 * @returns {String} currency format
 */
const getCustomFormattedDate = (value, monthDay, dayMonth) => {
  const pad = '00';
  const dt = new Date(value);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let day = `${dt.getDate()}`;
  day = pad.substring(0, pad.length - day.length) + day;
  const month = monthNames[dt.getMonth()];
  const year = dt.getFullYear();
  let hour = dt.getHours() % 12;
  // eslint-disable-next-line prefer-template
  hour = hour ? '' + hour : '12';
  hour = pad.substring(0, pad.length - hour.length) + hour;
  // eslint-disable-next-line prefer-template
  let min = '' + dt.getMinutes();
  min = pad.substring(0, pad.length - min.length) + min;
  const amPM = 12 - dt.getHours() > 0 ? 'am' : 'pm';
  let timeZone = dt.toString().match(/(\()(.*)(\))/)[2];
  const spanish = /\/es/.test(window.location.pathname);
  if (spanish) {
    const mappings = {
      eastern: 'hora del este',
      pacific: 'tiempo de pacifico',
      central: 'hora del centro',
      mountain: 'hora de la montaña',
      hawaii: 'hora del Hawaii'
    };
    for (const key in mappings) {
      if (timeZone.toLowerCase().includes(key)) {
        timeZone = mappings[key];
        break;
      }
    }
  }
  if (monthDay) {
    return `${month} ${day} ${year} ${hour}:${min} ${amPM} ${timeZone}`;
    // eslint-disable-next-line no-else-return
  } else if (dayMonth) {
    return `${day} ${month} ${year} ${hour}:${min} ${amPM} ${timeZone}`;
  } else {
    return `${day} ${month} ${year} ${hour}:${min} ${amPM} ${timeZone}`;
  }
};

export { currency, currencyRoundedInt, date, eq, getCustomFormattedDate, percentage, zipcode };
